import { TransportTaskType } from "./transport";
import { t } from "i18next";
import { TransportOrderInvoicingState } from "../common/enums";
import { TransportOrderProductItem } from "../product/product";
import { GeolocationPosition } from "../../models/workShiftTimeSlot/workTimeStartFormItem";
import { TransportOrderNotificationListItemDto } from "./transportOrderNotification";
import { AttachmentListItemDto } from "../attachment/attachment";

export interface OwnTransportOrdersQueryParameters {
    vehicleId?: string;
    timeFrameStartDate?: string;
    timeFrameEndDate?: string;
    selectedOrderStates?: TransportOrderState[];
    orderByAscending?: boolean;
}

export interface TransportOrderDto {
    id: string;
    name: string;
    vehicleId: string | null;
    employeeId: string | null;
    scheduledStartDateTime: string | null;
    scheduledEndDateTime: string | null;
    transportDetails: string | null;
    invoicingState: TransportOrderInvoicingState;
    senderName: string;
    senderBusinessId: string | null;
    senderCustomerId: string | null;
    receiverBusinessId: string | null;
    receiverCustomerId: string | null;
    driverComments: string | null;
    orderNumber: string | null;
    billingCustomerId: string | null;
    billingCustomerName: string | null;
    state: TransportOrderState;
    invoiceNewId: string | null;
    createdEmployeeId: string | null;
    createdDateTime: string | null;
    createdEmployeeName: string | null;
    modifiedEmployeeId: string | null;
    modifiedDateTime: string | null;
    latestTransportTaskType: TransportTaskType | null;
    latestTransportTaskTypeChangedDateTime: string | null;
    vehicleName: string | null;
    employeeName: string | null;
    receiverName: string | null;
    orderTypeId: string | null;
    formValues: string | null;
    uiSchema: string | null;
    formData: string | null;
    formTitle: string | null;
    products: TransportOrderProductItem[];
    transportOrderNotifications: TransportOrderNotificationListItemDto[];
    attachments?: AttachmentListItemDto[];
    totalSum: number | null;
    totalSumWithVat: number | null;
}

export type TransportOrderListItemDto = TransportOrderDto;
export type TransportOrderDetailsDto = TransportOrderDto;

export interface TransportOrderUpdateDto {
    name?: string;
    vehicleId?: string;
    employeeId?: string;
    scheduledStartDateTime?: string;
    scheduledEndDateTime?: string;
    state: TransportOrderState;
    transportDetails?: string;
    orderTypeId?: string;
    formData?: string;
    formValues?: string;
    uiSchema?: string;
    senderBusinessId?: string;
    senderCustomerId?: string;
    receiverBusinessId?: string;
    receiverCustomerId?: string;
    driverComments?: string;
    billingCustomerId?: string;
    modifiedEmployeeId: string;
    geolocation?: any;
    products?: TransportOrderProductItem[];
    location?: GeolocationPosition;
}

export enum TransportOrderState {
    OrderCreated = 0,
    PickedUp = 1,
    Delivered = 2,
    Cancelled = 3
}

export const transportOrderStateNames: Readonly<Record<TransportOrderState, string>> = Object.freeze({
    [TransportOrderState.OrderCreated]: "transport.order.orderCreated",
    [TransportOrderState.PickedUp]: "transport.order.pickedUp",
    [TransportOrderState.Delivered]: "transport.order.delivered",
    [TransportOrderState.Cancelled]: "transport.order.cancelled"
});

export const transportOrderStates = Object.freeze([
    { value: TransportOrderState.OrderCreated, name: transportOrderStateNames[TransportOrderState.OrderCreated] },
    { value: TransportOrderState.PickedUp, name: transportOrderStateNames[TransportOrderState.PickedUp] },
    { value: TransportOrderState.Delivered, name: transportOrderStateNames[TransportOrderState.Delivered] },
    { value: TransportOrderState.Cancelled, name: transportOrderStateNames[TransportOrderState.Cancelled] }
]);

export const transportOrderColor: Readonly<Record<TransportOrderState, string>> = Object.freeze({
    [TransportOrderState.OrderCreated]: "orange.main",
    [TransportOrderState.PickedUp]: "blue.main",
    [TransportOrderState.Delivered]: "green.main",
    [TransportOrderState.Cancelled]: "yellow.main"
});

export const getTranslatedOrderState = (state: number) => t(`transport.status.${TransportOrderState[state]}`);
